const styles = ({ screenSizes, spacing }) => ({
  padding: [spacing.sm, spacing.lg, spacing.lg, spacing.lg],
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {},
});

export default styles;
